import { getToken, removeBaseInfo, removeToken } from "@/common/cookie";
import { logConfig, logErr } from "../common/log";
import store from "@/store/index";
import { Message } from "element-ui";
import router from "./index";
import config from "@/config";
const whiteRouter = (store.state as any).whiteRouter;
const loginRouter = ['/login', '/registPhone'];
let messageInstance: any = null;
const mainMessage: any = (options: any) => {
  if (messageInstance) {
    return;
    messageInstance.close();
  }
  messageInstance = Message.warning(options)
}
router.beforeEach((to: any, from: any, next: any) => {
  config.reportRoot && console.groupEnd();
  // console.clear();
  config.reportRoot && console.group('router to:', to.name);
  logConfig("current version updatetime:", config.version);
  window.scrollTo(0, 0);
  // if (getToken()) {
  //   if(loginRouter.includes(to.path)) {
  //     next();
  //   } else {

  //   }
  // }
  // next()
  if (getToken()) {
    const state: any = store.state;
    const getter: any = store.getters;
    // if(to.path.indexOf('/detail')>=0) {
    //   const {roleSave} = getter;
    //   if(roleSave!==1) {
    //     return mainMessage("您尚未进行实名认证, 请先进行实名认证");
    //   }
    // }
    // justify logout
    if (loginRouter.includes(to.path)) {
      store.dispatch("account/clear");
      next();
    } else {
      if (whiteRouter.includes(to.path) || to.path.indexOf('/user') >= 0) {
        // whiteRouter include to.path

        next();
      } else {
        // store.dispatch('permission/getRole', store.state.account.role);
        // const role = store.getters['permission/role'];

        next();
        // if(!role) {
        //   return Message.warning("获取角色失败")
        // } else {
        //   if(store.state.account.asyncRouter) {
        //     next();
        //   } else {
        //     store.dispatch("permission/createRouter", role);
        //     let allRouters = store.getters['permission/allRouters'];
        //     let addRouters = store.getters['permission/addRouters'];
        //     store.dispatch('account/setRouter', addRouters);
        //     router.addRoutes(addRouters)
        //     router.options.routes = allRouters;
        //     whiteRouter.unshift(to.path);
        //     store.dispatch('account/setWhiteRouter', whiteRouter);
        //     next({ ...to, replace: true });
        //   }
        // }
      }
    }
  } else {
    if (whiteRouter.includes(to.path) || to.path.indexOf('/temp') >= 0 || to.path.indexOf('/pcm') >= 0 || to.path.indexOf('/detail') >= 0 || to.path.indexOf('/kunming') >= 0) {
      // whiteRouter include to.path
      next();
    } else {
      next('/login');
    }
  }
})
